import { render } from "./WidgetTable.vue?vue&type=template&id=78bed5e8&scoped=true"
import script from "./WidgetTable.vue?vue&type=script&lang=js"
export * from "./WidgetTable.vue?vue&type=script&lang=js"

import "./WidgetTable.vue?vue&type=style&index=0&id=78bed5e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78bed5e8"]])

export default __exports__